import styles from './Input.module.scss';
import ValidationErrorLabel from '../../ValidationErrorLabel/ValidationErrorLabel';

export function Input({
  isClosedVariant,
  type,
  placeholder,
  label,
  defaultValue,
  onChange,
  readOnly,
  value,
  onBlur,
  classes,
  error = false,
  accept,
  description = '',
  descriptionClass = null
}) {
  return (
    <div className={`${classes} ${isClosedVariant ? styles.InputClosedStyle : styles.InputComponent}`}>
      <label className={styles.label}>{label}</label>
      {description && <legend className={descriptionClass}>{description}</legend>}
      <input
        onBlur={onBlur}
        value={value}
        readOnly={readOnly}
        onChange={onChange}
        defaultValue={defaultValue}
        className={styles.InputStyles}
        type={type}
        placeholder={placeholder}
        accept={accept}
      />
      {error && <ValidationErrorLabel message={error} />}
    </div>
  );
}
